$(function () {
  setNewItemSlick()
});
$(window).on("resize",function(){
  setNewItemSlick()
});
function setNewItemSlick(){
  if(wW >= 990){
    $('.box-new-item-slider').not('.slick-initialized').slick({
      arrows:true,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      responsive: [{
        breakpoint: 990,
        settings: 'unslick'
      }]
    });
  }else{
    $('.box-new-item-slider.slick-initialized').slick('unslick');
  }
}